import I18n from 'I18n';
import { SkeletonDiv } from '../../common/SkeletonDiv';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
export default function InformationPopoverName({
  label,
  loading
}) {
  if (loading && typeof label === 'undefined') {
    return /*#__PURE__*/_jsx(SkeletonDiv, {
      blockSize: "20px",
      inlineSize: "45%",
      "aria-label": I18n.text('customerDataFiltersUI.propertyInformationPopover.propertyName.loading')
    });
  }
  return /*#__PURE__*/_jsx(Text, {
    as: "h5",
    typography: "heading-100",
    use: label ? 'default' : 'disabled',
    children: /*#__PURE__*/_jsx(TruncateString, {
      children: label || /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFiltersUI.propertyInformationPopover.propertyName.missing"
      })
    })
  });
}